import { CUSTOM_ROSTER_SELECTION_TYPE, FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { rosterAPI } from '@/providers/apis/roster/roster';
import moment from 'moment';
import RosterUserDetails from './m-roster-users/m-roster-users';
import RosterClassDetails from './m-roster-class/m-roster-class';
import RosterEnrollmentDetails from './m-roster-enrollment/m-roster-enrollment';
import RosterCourseDetails from './m-roster-course/m-roster-course';
import RosterOrgsDetails from './m-roster-orgs/m-roster-orgs';

@Component({
    name: 'm-roster-details',
    components: {
        'users-details': RosterUserDetails,
        'class-details': RosterClassDetails,
        'enrollment-details': RosterEnrollmentDetails,
        'course-details': RosterCourseDetails,
        'orgs-details': RosterOrgsDetails,

    },
})

export default class RosterDetails extends Vue {

    // -------------------------------------------------------------------
    // Properties
    @Prop()
    private rosterData: any;

    private get activeComponent() {
        return this.componentList[this.rosterData.activeType.recoredKey];
    }

    private componentList: any = {
        orgs: 'orgs-details',
        classes: 'class-details',
        users: 'users-details',
        courses: 'course-details',
        enrollments: 'enrollment-details',
    };



    // --------------------------------------------------------------------
    // Events


    // ---------------------------------------------------------------------
    // Actions
    private onClose() {
        this.$emit('onClose');
    }

    // ---------------------------------------------------------------------
    // Methods

}
